export function renderTemplate(
  { variant, ...props },
  templates,
  defaultVariant = 'Template01',
) {
  const Element = templates[variant ?? defaultVariant]
  return <Element {...props} />
}
